export default __webpack_public_path__ + "static/ana-lucia-gomes-52f469788dbbafc83887e7b376bf1f82.png";